import { Pipe, PipeTransform } from '@angular/core';
import * as VMasker from 'vanilla-masker';

@Pipe({
    name: 'cpfcnpj',
})
export class CpfCnpjPipe implements PipeTransform {

    public transform(value: any): any {
        if (!value) return null;

        const newValue = value.toString();
        const normalizedValue = newValue.replace(/[_\W]+/g, '');
        const pattern = (normalizedValue.length <= 11) ? '999.999.999-99?9' : '99.999.999/9999-99';
        return VMasker.toPattern(normalizedValue, pattern);
    }

}
